import { Route } from '@angular/router';
import { AppUrls } from '../../../../../../common/dto/app-urls';

export const ElementsRoute: Route = {
  path: AppUrls.Dashboard._.Guide._.Elements.relativeUrl,
  children: [
    {
      path: AppUrls.Dashboard._.Guide._.Elements._.ElementList.relativeUrl,
      loadComponent: () => import('./element-list/element-list.component').then(_ => _.ElementListComponent),
      pathMatch: 'full',
    },
    {
      path: AppUrls.Dashboard._.Guide._.Elements._.ElementEditor.relativeUrl,
      loadComponent: () => import('./element-editor/element-editor.component').then(_ => _.ElementEditorComponent),
    },
    {
      path: '**',
      redirectTo: AppUrls.Dashboard._.Guide._.Elements._.ElementList.relativeUrl,
    },
  ],
};
